module.exports = __webpack_public_path__ + "static/img/myshop.b1f7a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myshop.png
// module id = YdMN
// module chunks = 1